"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Parsowanie tekstowego formatu daty do Date
 * @param date data w formacie YYYY-MM-DD lub YYYY-MM-DD HH:mm:ss
 */
function dateParse(date) {
    if (date.length === 10) {
        return new Date(date + ' 00:00:00');
    }
    else {
        return new Date(date);
    }
}
exports.default = dateParse;
//# sourceMappingURL=dateParse.js.map